import { Box, Typography } from '@mui/material';
import type { WeekTokens } from './weekTokens';

type WeekProgressBarProps = {
  done: number;
  total: number;
  tokens: WeekTokens;
  /** Etikett t.ex. "Veckans framsteg". */
  label: string;
};

/**
 * WeekProgressBar — teens ADDITIVA veckoframstegs-lager (gamification). Extraherad
 * ur den tidigare TeenWeek så att den kan renderas ovanpå den gemensamma
 * dagskorts-strukturen via WeekView-flaggan showWeekProgress. Renderar inget när
 * veckan är tom (total === 0).
 */
const WeekProgressBar = ({ done, total, tokens, label }: WeekProgressBarProps) => {
  if (total <= 0) return null;
  const progress = (done / total) * 100;

  return (
    <Box
      sx={{
        bgcolor: tokens.cardBg,
        border: `1px solid ${tokens.cardBorder}`,
        borderRadius: '14px',
        p: '14px 18px',
        boxShadow: tokens.cardShadow,
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
        <Typography sx={{ fontSize: '0.8rem', fontWeight: 600, color: tokens.textSoft }}>
          {label}
        </Typography>
        <Typography sx={{ fontSize: '0.85rem', fontWeight: 700, color: tokens.text }}>
          {done}/{total}
        </Typography>
      </Box>

      <Box
        sx={{
          height: 10,
          borderRadius: 5,
          bgcolor: `${tokens.textSoft}22`,
          overflow: 'hidden',
          position: 'relative',
        }}
      >
        <Box
          sx={{
            height: '100%',
            width: `${progress}%`,
            borderRadius: 5,
            background: `linear-gradient(90deg, ${tokens.accent}, ${tokens.done}, ${tokens.accent})`,
            transition: 'width 0.5s ease-out',
            '@media (prefers-reduced-motion: reduce)': { transition: 'none' },
          }}
        />
      </Box>

      <Typography
        sx={{
          fontSize: '0.7rem',
          fontWeight: 500,
          color: tokens.textSoft,
          mt: 0.5,
          textAlign: 'right',
        }}
      >
        {Math.round(progress)}%
      </Typography>
    </Box>
  );
};

export default WeekProgressBar;
